<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5" v-if="parent_id != null">
          <section>
            <h1 class="pb-5">Session Info</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input name="name" class="w-full" v-model="form.name" />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Slug</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  class="w-full"
                  name="slug"
                  v-model="form.slug"
                  v-on:blur="validateSlug()"
                />
                <span class="text-danger text-sm" v-show="errors.has('slug')">{{
                  errors.first("slug")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor v-model="form.shortdesc" :config="{
                  plugins: ['blockcode'],
                  addbarAdd: ['text', 'card'],
                  css: '/article-editor/css/',
                  format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                  align: {
                      'left': 'text-left',
                      'center': 'text-center',
                      'right': 'text-right',
                      'justify': 'text-justify'
                  }
                }"></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.shortdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor v-model="form.longdesc" :config="{
                  plugins: ['blockcode'],
                  addbarAdd: ['text', 'card'],
                  css: '/article-editor/css/',
                  format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                  align: {
                      'left': 'text-left',
                      'center': 'text-center',
                      'right': 'text-right',
                      'justify': 'text-justify'
                  }
                }"></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.longdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <flat-pickr
                  :config="configFromdateTimePicker"
                  v-model="form.daterange[0]"
                  placeholder="From Date Time"
                  @on-change="onFromChange"
                />
                <span class="px-2">to</span>
                <flat-pickr
                  :config="configTodateTimePicker"
                  v-model="form.daterange[1]"
                  placeholder="To Date Time"
                  @on-change="onToChange"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Stage</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!--
                <vs-select v-model="form.venue">
                  <vs-select-item :value="`Stream 1`" :text="`Stream 1`" />
                  <vs-select-item :value="`Stream 2`" :text="`Stream 2`" />
                  <vs-select-item :value="`Stream 2`" :text="`Stream 2`" />
                  <vs-select-item :value="`Stream 3`" :text="`Stream 3`" />
                  <vs-select-item :value="`Main Stage`" :text="`Main Stage`" />
                </vs-select>
                -->
                <vs-input
                  v-validate="'required'"
                  name="venue"
                  class="w-full"
                  v-model="form.venue"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Speaker URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="speaker_url"
                  class="w-full"
                  v-model="form.speaker_url"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Internal Remark</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="3"
                  name="int_remark"
                  class="w-full"
                  v-model="form.int_remark"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Poster Image</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="file"
                  ref="poster"
                  name="poster"
                  class="w-full"
                  v-model="form.poster"
                  @change="setPoster"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('poster')"
                  >{{ errors.first("poster") }}</span
                >
              </div>
            </div>
            <div class="vx-row my-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Streaming Source</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="live_engine" vs-value="zoom"
                      >Zoom</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="live_engine" vs-value="ivs"
                      >IVS</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="live_engine" vs-value="youtube"
                      >Youtube</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="live_engine" vs-value="vimeo"
                      >Vimeo</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="live_engine" vs-value="later"
                      >Add it Later</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <template v-if="live_engine == 'zoom'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Please select zoom account</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="form.zoom_account_no" vs-value="acc_1"
                        >Account 1</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio v-model="form.zoom_account_no" vs-value="acc_2"
                        >Account 2</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-row mb-6" v-if="form.zoom_status == 1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Type of Session</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="form.session_type" vs-value="webinar"
                        >Webinar</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio v-model="form.session_type" vs-value="meeting"
                        >Meeting</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <div
              class="vx-row mb-6"
              v-if="live_engine == 'youtube' || live_engine == 'vimeo'"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span>Streaming URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="viewer_endpoint_url"
                  class="w-full"
                  v-model="viewer_endpoint_url"
                />
              </div>
            </div>
          </section>
          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create Session</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ArticleEditor from "@/components/ArticleEditor.vue";

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: { flatPickr, ArticleEditor },
  data: () => ({
    isClone: false,
    timezones: timezones,
    suffixParams: "",
    valid: true,
    editorOption: {
      modules: {
        toolbar: "#toolbar"
      }
    },
    editor2Option: {
      modules: {
        toolbar: "#toolbar-2"
      }
    },
    parent_id: null,
    form: {
      s: null,
      e: null,
      name: "",
      slug: "",
      daterange: [moment().unix(), moment().unix()],
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      shortdesc: "",
      longdesc: "",
      timezone: null,
      venue: "",
      poster: "",
      zoom_status: 0,
      zoom_account_no: "acc_2",
      session_type: "webinar",
      mode: "online",
      freeevent: 1,
      privacy: "private",
      private_token: "",
      speaker_url: "",
      int_remark: ""
    },
    live_engine: "ivs",
    viewer_endpoint_url: "",
    concurrentList: [
      { value: 0, text: "Unlimited" },
      { value: 1, text: "1" },
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
      { value: 5, text: "5" }
    ],
    currencyForm: {
      currency: "THB",
      hasReference: false,
      altcurrencycode: "USD",
      altcurrencyrate: null
    },
    ticketForm: {
      title: "Session Ticket",
      slug: "session-ticket",
      shortdesc: "",
      price: 0,
      fullprice: 0,
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      ticket_note: "",
      qty: null,
      requiredqty: null,
      minqty: null,
      maxqty: null,
      publish_status: 1,
      weight: 0,
      live_concurrent_session: 0
    },
    disableZoomToggle: false,
    datetime: null,
    configFromdateTimePicker: {
      minDate: new Date(),
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    configTodateTimePicker: {
      minDate: null,
      minDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    file: {
      poster: null
    }
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  created() {
    this.$vs.loading();

    /*
    console.log(new Date());
    console.log(moment().unix());
    */

    this.timezones = Object.keys(this.timezones).map(item => {
      return { key: item, value: item };
    });
    setTimeout(() => {
      if (this.e) {
        Service.Event.get(this.e)
          .then(res => {
            this.parent_id = res.data.event.event_id;
            this.form.timezone = res.data.event.timezone;

            this.configFromdateTimePicker.minDate =
              moment(res.data.event.datetime, "YYYY-MM-DD HH:mm")
                .subtract(100, "days")
                .unix() * 1000;

            this.configFromdateTimePicker.maxDate =
              moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm")
                .add(100, "days")
                .unix() * 1000;

            this.configTodateTimePicker.minDate =
              moment(res.data.event.datetime, "YYYY-MM-DD HH:mm")
                .subtract(100, "days")
                .unix() * 1000;

            this.configTodateTimePicker.maxDate =
              moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm")
                .add(100, "days")
                .unix() * 1000;
          })
          .catch(e => {
            /* this.$router.push("/pages/error-404").catch(() => {}); */
          });
      }

      this.$vs.loading.close();
      this.form.s = this.s;
    }, 1500);
  },
  watch: {
    live_engine: function(newVal, oldVal) {
      if (newVal == "zoom") {
        this.form.zoom_status = 1;
        this.disableZoomToggle = false;
      } else {
        this.form.zoom_status = 0;
        this.disableZoomToggle = true;
      }
    },
    "form.name": function(newVal, oldVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    "form.slug": function(newVal, oldVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.suffixParams = "?s=" + this.s + "&e=" + this.e;
    }, 1000);
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          Service.Event.search(this.form.slug).then(res => {
            if (res.data.results.length > 0) {
              this.$vs.notify({
                title: "Oops!",
                text: "ERROR : This slug already used by others.",
                color: "danger",
                fixed: true
              });
              return;
            } else {
              this.submit();
            }
          });
        }
      });
    },
    validateSlug() {
      this.$vs.loading();
      Service.Event.search(this.form.slug).then(res => {
        if (res.data.results.length > 0) {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : This slug already used by others.",
            color: "danger",
            fixed: true
          });
        }
        this.$vs.loading.close();
      });
    },
    submit() {
      /*CONVERT DATE FORMAT */
      this.form.daterange[0] = moment(
        this.form.daterange[0],
        "DD-MM-YYYY HH:mm"
      ).format("YYYY-MM-DD HH:mm");
      this.form.daterange[1] = moment(
        this.form.daterange[1],
        "DD-MM-YYYY HH:mm"
      ).format("YYYY-MM-DD HH:mm");

      var slugify = require("slugify");
      this.form.slug = slugify(this.form.slug, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }

      this.form.s = this.s;
      this.form.e = this.e;
      this.form = {
        ...this.form,
        ...this.currencyForm,
        parent_id: this.parent_id,
        ticket: this.ticketForm,
        mode: "session"
      };

      this.$vs.loading();

      Service.Session.create(this.form)
        .then(res => {
          if (res.success) {
            //this.$router.push("/conferences/sessions/");
            if (res.success) {
              Promise.all([
                this.doUploadFile(res.data.event_id),
                this.doCreateVideo(res.data.event_id)
              ]).then(() => {
                this.$vs.notify({
                  title: "Success",
                  text: "Update complete.",
                  color: "success"
                });
                this.$vs.loading.close();
                setTimeout(() => {
                  this.$router.push(
                    "/conferences/sessions/" +
                      res.data.slug +
                      "/view?" +
                      this.suffixParams
                  );
                }, 1000);
              });
            }
          }
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    },
    async doUploadFile(id) {
      var formData = new FormData();
      formData.append("e", this.e);

      if (this.file.poster != null) {
        formData.append("poster", this.file.poster);
      }

      Service.Session.upload(id, formData)
        .then(res => {
          this.$vs.loading.close();
          if (res.success) {
            return res;
          }
        })
        .catch(e => {
          return e;
        });
    },
    async doCreateVideo(id) {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.createVideo(params, {
        object_id: id,
        live_engine: this.live_engine,
        viewer_endpoint_url: this.viewer_endpoint_url
      })
        .then(res => {
          return res;
        })
        .catch(e => {
          return e;
        });
    },
    setPoster(e) {
      this.file.poster = e.target.files[0];
    },
    onEditorBlur(quill) {
      //console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      //console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      //console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      //console.log("editor change!", quill, html, text);
      //this.content = html;
    },
    onFromChange(selectedDates, dateStr, instance) {
      //et min = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configTodateTimePicker, "minDate", min);
    },
    onToChange(selectedDates, dateStr, instance) {
      //let max = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configFromdateTimePicker, "maxDate", max);
    }
  }
};
</script>
<style>
.editor {
  height: 10rem;
  margin-bottom: 0px;
}
</style>
